module.exports = __webpack_public_path__ + "static/testimonial-abis-logo.0497c01b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/testimonials/testimonial-abis-logo.png
// module id = 1300
// module chunks = 35783957827783